/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectReceivedAdmins = (state) =>
  state['feature/get-admins'] || initialState;
//
export const getAdminsLoader = createSelector(
  [selectReceivedAdmins],
  (state) => state.isLoading
);
//
export const getAdminsError = createSelector(
  [selectReceivedAdmins],
  (state) => state.errorMessage
);
//
export const getAdminsSuccess = createSelector(
  [selectReceivedAdmins],
  (state) => state.isSuccess
);
//
export const getAdminsList = createSelector(
  [selectReceivedAdmins],
  (state) => state.allAdmins
);
//
export const removeAdminsLoader = createSelector(
  [selectReceivedAdmins],
  (state) => state.isRemoving
);
//
export const removeAdminsError = createSelector(
  [selectReceivedAdmins],
  (state) => state.removingError
);
//
export const removeAdminsSuccess = createSelector(
  [selectReceivedAdmins],
  (state) => state.isRemovingCompleted
);
//
export const masterAdminsLoader = createSelector(
  [selectReceivedAdmins],
  (state) => state.isMasterLoading
);
//
export const masterAdminsError = createSelector(
  [selectReceivedAdmins],
  (state) => state.masterErrorMessage
);
//
export const masterAdminsSuccess = createSelector(
  [selectReceivedAdmins],
  (state) => state.isMasterSuccess
);
//
export const getMasterAdmin = createSelector(
  [selectReceivedAdmins],
  (state) => state.masterAdmin
);
//
export const changeAdminsLoader = createSelector(
  [selectReceivedAdmins],
  (state) => state.isChanging
);
//
export const changeAdminsError = createSelector(
  [selectReceivedAdmins],
  (state) => state.changingError
);
//
export const changeAdminsSuccess = createSelector(
  [selectReceivedAdmins],
  (state) => state.isChangingCompleted
);
